import { isUndefined } from "lodash";
import { corpViewTypes } from "utils/CommonConstants";
import { getAllBreakupLists } from "../MyLists";

export const PAGE_SIZE = 50;

export const getPropertyName = (property: any) => {
  if (property?.propertyName && property?.propertyName?.trim().length > 0) {
    return property?.propertyName;
  }
  return property?.inncode;
};

export const getImplementedPlanCount = (view: string, property: any) => {
  let implementedPlansCountText;
  if (view === "dashboard") {
    implementedPlansCountText = property.implementedPlansCount;
  } else {
    implementedPlansCountText = `${property.implementedPlansCount}`;
    if (property.implementedPlansCountStatusBreakUp?.overdue > 0) {
      implementedPlansCountText += " *";
    }
  }
  return implementedPlansCountText;
};

export const getBrandOrInitPlanCountStatus = (view: string, property: any) => {
  let result = {};
  if (view === "dashboard") {
    if (property?.managementCompany) result = { title: property?.managementCompany };
    else result = {};
  } else {
    if (property.brandDeadlineInitiativePlansCountStatusBreakup) {
      const title = property.brandDeadlineInitiativePlansCount;
      const list = getAllBreakupLists(property?.brandDeadlineInitiativePlansCountStatusBreakup, true);

      result = { title, list };
    } else {
      result = {};
    }
  }
  return result;
};

export function createPropertyRowData(
  propertyName: string,
  inncode: "string",
  inncodeMappingUserName: string,
  brandName: string,
  implementedPlansCount: any,
  implementedPlansCountStatusBreakUp: any,
  isChecked: any,
  inncodeMappingIds: any,
  item: any
) {
  return {
    propertyName,
    inncode,
    inncodeMappingUserName,
    brandName,
    implementedPlansCount,
    implementedPlansCountStatusBreakUp,
    history: isUndefined(item.history) ? [] : item.history,
    isChecked,
    inncodeMappingIds,
    inncodeusers: item?.inncodeusers,
    lastAssignmentDate: item?.lastAssignmentDate
  };
}

export const getRowsForSc = (propertiesList: any, selectAllProperties: boolean) => {
  const properties = propertiesList?.map((item: any) => {
    return createPropertyRowData(
      item.propertyName,
      item.inncode,
      item.inncodeMappingUserName,
      item.brandName,
      item.implementedPlansCount,
      item.implementedPlansCountStatusBreakUp,
      !item.inncodeMappingUserName ? false : !isUndefined(item.isChecked) ? item.isChecked : selectAllProperties,
      item.inncodeMappingIds,
      item
    );
  });
  return properties;
};

export const updateSelectedMappingIds = (data: any) => {
  const selectedList: any = [];
  data?.forEach((child: any) => {
    if (child.isChecked) {
      if (child.inncodeMappingIds?.length) {
        child.inncodeMappingIds.map((innCode: number, index: number) => {
          const list = {
            id: innCode,
            hltId: child.inncodeusers[index],
            innCode: child.inncode
          };
          selectedList.push(list);
        });
      } else {
        const list = {
          id: null,
          hltId: "",
          innCode: ""
        };
        selectedList.push(list);
      }
    } else if (!child.isChecked && child.history?.length) {
      child.history.forEach((subChild: any) => {
        if (subChild.isChecked) {
          const list = {
            id: subChild.mappingId,
            hltId: subChild.hltId,
            innCode: subChild.innCode
          };
          selectedList.push(list);
        }
      });
    }
  });
  return selectedList;
};

/**
 * Appends `view` and, when the view is the "myList" view, the `myListType`/`myListId`
 * fields to a given payload. Mirrors the ternary used across the various
 * property-list API calls.
 */
export const appendViewAndMyListFields = (payload: any, view: string, myListType: any, selectedListId: any) => {
  let payloadData = { ...payload, view };
  payloadData = view === corpViewTypes.myList ? { ...payloadData, myListType, myListId: selectedListId } : payloadData;
  return payloadData;
};
